// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.why-pamo-header {
  font-size: 50px;
}

.why-pamo-lottie-container .why-pamo-lottie-card {
  border: 1px solid rgba(192, 192, 192, 0.342);
  width: 300px;
}

.trade-card-header {
  font-size: 50px;
  margin-top: -30%;
}

.trade-card-body {
  text-align: justify;
  font-size: 14px;
}

.why-pamo-lottie-col {
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
}

.text-col {
  margin-top: 10% !important;
}

.lottie-col {
  margin-top: 10% !important;
}

.trade-card-section {
  height: auto;
  margin-bottom: 10% !important;
}

@media only screen and (max-width: 942px) {
  .why-pamo-header {
    font-size: 50px !important;
  }
  .why-pamo-lottie-card {
    border: 1px solid rgba(192, 192, 192, 0.342);
    width: 210px;
  }
  .lottie-animation {
    width: 180px !important;
  }
  .why-pamo-btn {
    font-size: 12px !important;
  }
}
@media only screen and (max-width: 767px) {
  .why-pamo-header {
    font-size: 40px !important;
  }
  .text-col {
    font-size: 40px !important;
    padding-top: 125% !important;
    position: absolute;
    padding-left: 50px !important;
    padding-right: 50px !important;
    padding-bottom: 10% !important;
  }
  .lottie-col {
    margin-top: -20% !important;
  }
  .trade-card-section {
    height: auto;
    margin-bottom: 15% !important;
  }
}
@media only screen and (max-width: 703px) {
  .why-pamo-header {
    font-size: 30px !important;
  }
  .slide-container {
    padding-left: 25%;
  }
  .why-pamo-lottie-card {
    border: 1px solid rgba(192, 192, 192, 0.342);
    width: 210px;
  }
  .lottie-animation {
    width: 180px !important;
  }
  .why-pamo-btn {
    font-size: 12px !important;
  }
  .trade-card-header {
    font-size: 30px !important;
  }
  .why-pamo-header {
    font-size: 30px !important;
  }
}
@media only screen and (max-width: 555px) {
  .why-pamo-header {
    font-size: 30px !important;
  }
  .slide-container {
    padding-left: 70%;
  }
}
@media only screen and (max-width: 412px) {
  .why-pamo-header {
    font-size: 30px !important;
  }
}
@media only screen and (max-width: 430px) {
  .why-pamo-header {
    font-size: 30px !important;
  }
  .why-pamo-lottie-card {
    border: 1px solid rgba(192, 192, 192, 0.342);
    width: 260px;
  }
  .text-col {
    font-size: 40px !important;
    padding-top: 120% !important;
    position: absolute;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
  .lottie-col {
    margin-top: -35% !important;
  }
  .slide-container {
    display: inline !important;
  }
  .why-pamo-lottie-card-slide {
    padding-left: 12% !important;
  }
}
@media only screen and (max-width: 370px) {
  .why-pamo-header {
    font-size: 30px !important;
  }
  .text-col {
    font-size: 40px !important;
    padding-top: 180% !important;
    position: absolute;
    padding-left: 30px !important;
    padding-right: 30px !important;
    padding-bottom: 50% !important;
  }
  .why-pamo-lottie-card-slide {
    padding-left: 15% !important;
  }
  .trade-card-section {
    height: auto;
    margin-bottom: 10% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/home/components/why-pamo/why-pamo.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAGI;EACI,4CAAA;EACA,YAAA;AAAR;;AAIA;EACI,eAAA;EACA,gBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,eAAA;AADJ;;AAIA;EAEI,aAAA;EACA,iBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,0BAAA;AAFJ;;AAKA;EACI,0BAAA;AAFJ;;AAKA;EACI,YAAA;EACA,6BAAA;AAFJ;;AAMA;EAEI;IACI,0BAAA;EAJN;EAWE;IACI,4CAAA;IACA,YAAA;EATN;EAYE;IACI,uBAAA;EAVN;EAYE;IACI,0BAAA;EAVN;AACF;AAcE;EACE;IACI,0BAAA;EAZN;EAeE;IACI,0BAAA;IACA,4BAAA;IACA,kBAAA;IACA,6BAAA;IACA,8BAAA;IACA,8BAAA;EAbN;EAgBE;IACI,2BAAA;EAdN;EAgBE;IACI,YAAA;IACA,6BAAA;EAdN;AACF;AAoBE;EACE;IACI,0BAAA;EAlBN;EAoBE;IACI,iBAAA;EAlBN;EAoBE;IACI,4CAAA;IACA,YAAA;EAlBN;EAoBE;IACI,uBAAA;EAlBN;EAoBE;IACI,0BAAA;EAlBN;EAqBE;IACI,0BAAA;EAnBN;EAsBE;IACI,0BAAA;EApBN;AACF;AAgCE;EACE;IACI,0BAAA;EA9BN;EAgCE;IACI,iBAAA;EA9BN;AACF;AAiCE;EACE;IACI,0BAAA;EA/BN;AACF;AAqCE;EACE;IACI,0BAAA;EAnCN;EAsCE;IACI,4CAAA;IACA,YAAA;EApCN;EAuCE;IACI,0BAAA;IACA,4BAAA;IACA,kBAAA;IACA,6BAAA;IACA,8BAAA;EArCN;EAwCE;IACI,2BAAA;EAtCN;EAyCE;IACG,0BAAA;EAvCL;EA2CE;IACI,4BAAA;EAzCN;AACF;AA6CE;EACE;IACI,0BAAA;EA3CN;EA8CE;IACI,0BAAA;IACA,4BAAA;IACA,kBAAA;IACA,6BAAA;IACA,8BAAA;IACA,8BAAA;EA5CN;EA+CG;IACG,4BAAA;EA7CN;EA+CE;IACI,YAAA;IACA,6BAAA;EA7CN;AACF","sourcesContent":[".why-pamo-header {\n    font-size:50px;\n}\n\n.why-pamo-lottie-container{\n    .why-pamo-lottie-card{\n        border:1px solid rgba(192, 192, 192, 0.342);\n        width:300px;\n    }\n}\n\n.trade-card-header{\n    font-size:50px;\n    margin-top: -30%;\n}\n\n.trade-card-body{\n    text-align: justify;\n    font-size: 14px;\n}\n\n.why-pamo-lottie-col{\n    // width:350px !important;\n    display:flex;\n    flex-wrap: nowrap;\n    overflow: auto;\n}\n\n.text-col{\n    margin-top: 10% !important;\n}\n\n.lottie-col{\n    margin-top: 10% !important; \n}\n\n.trade-card-section{\n    height:auto;\n    margin-bottom: 10% !important;\n}\n\n\n@media only screen and (max-width: 942px) {\n\n    .why-pamo-header{\n        font-size:50px !important;\n    }\n\n    .slide-container{\n        // padding-left:20%;\n    }\n\n    .why-pamo-lottie-card{\n        border:1px solid rgba(192, 192, 192, 0.342);\n        width:210px;\n    }\n\n    .lottie-animation{\n        width:180px !important;\n    }\n    .why-pamo-btn {\n        font-size:12px !important;\n    }\n\n  }\n\n  @media only screen and (max-width: 767px) {\n    .why-pamo-header{\n        font-size:40px !important;\n    }\n\n    .text-col{\n        font-size:40px !important;\n        padding-top: 125% !important;\n        position: absolute;\n        padding-left: 50px !important;\n        padding-right: 50px !important;\n        padding-bottom: 10% !important;\n    }\n\n    .lottie-col{\n        margin-top: -20% !important; \n    }\n    .trade-card-section{\n        height:auto;\n        margin-bottom: 15% !important;\n    }\n    \n\n  }\n\n\n  @media only screen and (max-width: 703px) {\n    .why-pamo-header{\n        font-size:30px !important;\n    }\n    .slide-container{\n        padding-left:25%;\n    }\n    .why-pamo-lottie-card{\n        border:1px solid rgba(192, 192, 192, 0.342);\n        width:210px;\n    }\n    .lottie-animation{\n        width:180px !important;\n    }\n    .why-pamo-btn {\n        font-size:12px !important;\n    }\n\n    .trade-card-header {\n        font-size:30px !important;\n    }\n\n    .why-pamo-header {\n        font-size:30px !important;\n    }\n  }\n\n//   @media only screen and (max-width: 555px) {\n//     .why-pamo-header{\n//         font-size:30px !important;\n//     }\n//     .slide-container{\n//         padding-left:45%;\n//     }\n//   }\n\n  @media only screen and (max-width: 555px) {\n    .why-pamo-header{\n        font-size:30px !important;\n    }\n    .slide-container{\n        padding-left:70%;\n    }\n  }\n\n  @media only screen and (max-width: 412px) {\n    .why-pamo-header{\n        font-size:30px !important;\n    }\n    // .slide-container{\n    //     padding-left:100%;\n    // }\n  }\n\n  @media only screen and (max-width: 430px) {\n    .why-pamo-header{\n        font-size:30px !important;\n    }\n\n    .why-pamo-lottie-card{\n        border:1px solid rgba(192, 192, 192, 0.342);\n        width:260px;\n    }\n\n    .text-col{\n        font-size:40px !important;\n        padding-top: 120% !important;\n        position: absolute;\n        padding-left: 30px !important;\n        padding-right: 30px !important;\n    }\n\n    .lottie-col{\n        margin-top: -35% !important; \n    }\n\n    .slide-container{\n       display:inline !important;\n      \n    }\n\n    .why-pamo-lottie-card-slide{\n        padding-left: 12% !important;\n    }\n\n  }\n\n  @media only screen and (max-width: 370px) {\n    .why-pamo-header{\n        font-size:30px !important;\n    }\n\n    .text-col{\n        font-size:40px !important;\n        padding-top: 180% !important;\n        position: absolute;\n        padding-left: 30px !important;\n        padding-right: 30px !important;\n        padding-bottom:50% !important;\n    }\n\n     .why-pamo-lottie-card-slide{\n        padding-left: 15% !important;\n    }\n    .trade-card-section{\n        height:auto;\n        margin-bottom: 10% !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
